import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetCompanyAccountsRequestSchema,
  TGetCompanyAccountsResponseSchema,
} from "./getCompanyAccounts.schema";

export const getCompanyAccounts = (axios: IAxiosInstance) => {
  return async (params: TGetCompanyAccountsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetCompanyAccountsResponseSchema>
    >(`/api/companies/${params.companyID}/accounts`, {
      params,
    });

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
